import { ApiFailure } from "./api";

export interface RideFailure {
  /** Read the trip again: Pony's state may differ from ours. */
  refetch: boolean;
  notice?: { text: string; retryAfter?: number };
}

/** What the ride screen does when pause, resume or finish fails. */
export function rideFailure(e: unknown, fallback: string): RideFailure {
  if (e instanceof ApiFailure) {
    if (e.code === "VEHICLE_NOT_RESPONDING")
      return {
        refetch: false,
        notice: {
          text: `Le vélo ne répond pas. Réessayez dans ${e.retryAfter ?? 5} s.`,
          ...(e.retryAfter && { retryAfter: e.retryAfter }),
        },
      };
    if (e.code === "NO_ONGOING_TRIP") return { refetch: true };
    if (e.code === "ILLEGAL_STATE")
      return {
        refetch: true,
        notice: { text: "Action impossible pour le moment. Réessayez dans quelques secondes." },
      };
  } else if (e instanceof Error && (e.name === "TimeoutError" || e.name === "AbortError")) {
    // Pony waits for the bike's lock (up to ~90 s): the action may have gone through anyway.
    return {
      refetch: true,
      notice: { text: "Le vélo prend plus de temps que prévu. Vérifiez son état, puis réessayez." },
    };
  }
  return { refetch: false, notice: { text: fallback } };
}
